import { Alert, Center, Loader, Stack, Text } from "@mantine/core";

export function LoadingState({ label = "Loading…" }: { label?: string }) {
  return (
    <Center mih={200}>
      <Stack align="center" gap="xs">
        <Loader />
        <Text size="sm" c="dimmed">
          {label}
        </Text>
      </Stack>
    </Center>
  );
}

export function ErrorState({ error }: { error: unknown }) {
  const msg = error instanceof Error ? error.message : String(error);
  return (
    <Alert color="red" title="Failed to load data">
      {msg}
    </Alert>
  );
}
